import React, { useMemo, useRef, useState, useEffect } from "react";
import useDynamicCSS from "../component/useDynamicCss";
import {
  FaEye,
  FaHome,
  FaLock,
  FaRegEye,
  FaRegEyeSlash,
  FaWhatsapp,
} from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { isEmpty } from "lodash";
import { Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { t } from "i18next";
import OutsideClickHandler from "react-outside-click-handler";
import obj from "../Utils/helpers";
import SignupSlider from "./SignupSlider";
const ICON_URL = "/assets/NewIcon/icon-error.svg?v=1776751585885";

const Register = () => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors, touchedFields },
  } = useForm();
  const navigate = useNavigate();
  const inputRef = useRef(null);

  const setUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.setUser;
  });
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const [showPassword2, setShowPassword2] = useState(true);
  const handleShow = () => {
    setShowPassword(!showPassword);
  };
  const handleShow2 = () => {
    setShowPassword2(!showPassword2);
  };

  const onSubmit = async (body) => {
    setLoading(true);
    localStorage.clear();

    const { status, data: response_users1 } = await apiPost(
      apiPath.registerUser,
      {
        username: body?.username,
        password: body?.password,
        uniqueId: Math.random() * 10000,
        phone_number: body?.mobile?.substring(
          inputRef?.current?.state.selectedCountry?.countryCode?.length,
          body?.mobile?.toString()?.length,
        ),
        country_code: inputRef?.current?.state.selectedCountry?.countryCode,
        refreralCode: body?.refreralCode || "",
      },
    );
    if (status === 200) {
      if (response_users1.success) {
        localStorage.setItem("token", response_users1?.results?.token);
        localStorage.setItem(
          "refresh_token",
          response_users1?.results?.refresh_token,
        );
        setUser(jwt_decode(response_users1?.results.token));
        navigate("/");
        window.location.reload();
      } else {
        toast.error(response_users1?.message);
      }
    } else {
      toast.error(response_users1?.message);
    }

    setLoading(false);
  };
  const { search } = useLocation();

  let query = search?.split("=")[1];
  if (query) {
    if (obj?.stringReplace) {
      // Remove '&fbclid' and '@device_id' if present
      query = obj.stringReplace(query, "&fbclid");
      query = obj.stringReplace(query, "&device_id");
    }
  }
  let code = query;

  let codeCondition = search?.split("=")?.includes("?referral_code")
    ? true
    : false;

  useEffect(() => {
    if (codeCondition) {
      setValue("refreralCode", code);
    }
  }, [code, codeCondition]);

  const password = watch("password", "");
  const isTouched = touchedFields.password;

  // Validation rule states
  const rules = {
    length: password.length >= 6 && password.length <= 20,
    alpha: /[a-zA-Z]/.test(password),
    number: /[0-9]/.test(password),
  };

  // Returns className: "disabled" (untouched), "error" (failing), "" (passing)
  const getRuleClass = (rulePassed) => {
    if (!isTouched) return "password-message disabled";
    return rulePassed ? "password-message success" : "password-message error";
  };
  return (
    <div className="popup-page popup-page--active popup-page--align-top">
      <div className="popup-page__backdrop" />{" "}
      <OutsideClickHandler onOutsideClick={() => navigate(-1)}>
        <div className="popup-page__main popup-page-main popup-page-main--show">
          <div className="popup-page-main__header">
            <div className="popup-page-main__title">{t("Singup")}</div>
            <div
              onClick={() => navigate("/")}
              className="popup-page-main__close ng-star-inserted"
            />
          </div>
          <div className="popup-page-main__container">
            <div className="content login-biometric-content">
              {" "}
              <div
                _ngcontent-serverapp-c381631582
                className="logo-box"
                style={{
                  "background-image": 'url("/assets/Other/logo.png")',
                }}
              />
              <SignupSlider/>
              <Form
                onSubmit={handleSubmit(onSubmit)}
                className="ng-untouched ng-pristine ng-invalid ng-star-inserted"
              >
                <div style={{ background: "transparent" }} className="menu-box">
                  <div className="input-group">
                    <label>
                      <span>{t("Username")}</span>
                      <span className="required-mark ng-star-inserted">*</span>
                    </label>
                    <input
                      type="text"
                      inputsanitizer
                      className="input ng-untouched ng-pristine ng-invalid"
                      placeholder={t("CharactersPlaceholder")}
                      {...register("username", {
                        required: t("Enter_Valid_Username"),

                        validate: {
                          noLeadingSpaces: (value) =>
                            !/^\s/.test(value) || t("Enter_Valid_Username"),

                          noTrailingSpaces: (value) =>
                            !/\s$/.test(value) || t("Enter_Valid_Username"),

                          alphanumericOnly: (value) =>
                            /^[a-zA-Z0-9 ]*$/.test(value) ||
                            t("Only_Alphabets_And_Numbers_Allowed"),

                          noOnlySpaces: (value) =>
                            value.trim().length > 0 ||
                            t("Enter_Valid_Username"),

                          mustContainAlphabet: (value) =>
                            /[a-zA-Z]/.test(value) ||
                            t("Username_Must_Contain_At_Least_One_Letter"),

                          minLength: (value) =>
                            value.trim().length >= 3 || t("Min3User"),

                          maxLength: (value) =>
                            value.trim().length <= 30 || t("Max30User"),
                        },
                      })}
                    />
                    {!isEmpty(errors?.username?.message) && (
                      <div class="alert">{errors?.username?.message}</div>
                    )}
                  </div>
                  <div className="input-group password">
                    <div
                      onClick={() => handleShow()}
                      _ngcontent-serverapp-c2292208966
                      className={`eyes ${!showPassword ? "active" : ""} `}
                    />
                    <label>
                      <span>{t("Password")}</span>
                      <span className="required-mark ng-star-inserted">*</span>
                    </label>
                    <input
                      type={!showPassword ? "text" : "password"}
                      className="input ng-untouched ng-pristine ng-invalid"
                      placeholder={t("PasswordPlaceholder")}
                      {...register("password", {
                        required: t("PasswordRequired"),
                        minLength: {
                          value: 6,
                          message: t("PasswordBetween"),
                        },
                        maxLength: {
                          value: 20,
                          message: t("PasswordBetween"),
                        },
                        validate: {
                          hasAlphabet: (value) =>
                            /[a-zA-Z]/.test(value) ||
                            t("PasswordAtLeastAlphabet"),
                          hasNumber: (value) =>
                            /[0-9]/.test(value) || t("PasswordAtLeastNumber"),
                        },
                      })}
                    />
                    {!isEmpty(errors?.password?.message) && (
                      <div class="alert">{errors?.password?.message}</div>
                    )}

                    <div className="password-message-block">
                      {/* Rule 1: Length */}
                      <div className={getRuleClass(rules.length)}>
                        <span
                          className="icon"
                          style={{ maskImage: `url("${ICON_URL}")` }}
                        />
                        <span className="message">
                          {" "}
                          {t("PasswordBetween")}{" "}
                        </span>
                      </div>

                      {/* Rule 2: Alphabet */}
                      <div className={getRuleClass(rules.alpha)}>
                        <span
                          className="icon"
                          style={{ maskImage: `url("${ICON_URL}")` }}
                        />
                        <span className="message">
                          {" "}
                          {t("PasswordAtLeastAlphabet")}{" "}
                        </span>
                      </div>

                      {/* Rule 3: Number */}
                      <div className={getRuleClass(rules.number)}>
                        <span
                          className="icon"
                          style={{ maskImage: `url("${ICON_URL}")` }}
                        />
                        <span className="message">
                          {" "}
                          {t("PasswordAtLeastNumber")}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ background: "transparent" }} className="menu-box">
                  {/* <div className="input-group phone-number ng-star-inserted">
                    <label>
                      <span>{t("PhoneNumber")}</span>
                      <span className="required-mark ng-star-inserted">*</span>
                    </label>
                    <div
                      _ngcontent-serverapp-c2105323994
                      className="input-wrap phone-wrap"
                    >
                      <div
                        _ngcontent-serverapp-c2105323994
                        className="phone-area-code"
                      >
                        <div
                          _ngcontent-serverapp-c2105323994
                          className="lang-select"
                        >
                          <button
                            style={{ background: "#364848" }}
                            _ngcontent-serverapp-c2105323994
                            className="btn-select only"
                          >
                            <li _ngcontent-serverapp-c2105323994>
                              <img
                                _ngcontent-serverapp-c2105323994
                                value="BD"
                                alt="BD"
                                src="/assets/Other/BD.png"
                                loading="lazy"
                              />
                              <span _ngcontent-serverapp-c2105323994>+880</span>
                            </li>
                          </button>
                        </div>
                      </div>
                      <input
                        _ngcontent-serverapp-c2105323994
                        type="number"
                        inputMode="tel"
                        className="input ng-untouched ng-pristine ng-invalid"
                        placeholder="Enter your phone number."
                        {...register("mobile", {
                          required: "Mobile number is required",
                          pattern: {
                            value: /^(?:\+88|88)?01[3-9]\d{8}$/,
                            message: "Enter a valid Bangladesh mobile number",
                          },
                        })}
                      />
                      <input
                        _ngcontent-serverapp-c2105323994
                        className="clear"
                        style={{
                          "mask-image":
                            'url("/assets/NewIcon/icon-cross-type10.svg?v=1776751585885")',
                        }}
                      />
                    </div>
                    {!isEmpty(errors?.mobile?.message) && (
                      <div class="alert ">{errors?.mobile?.message}</div>
                    )}
                  </div> */}

                  <div className="input-group phone-number ng-star-inserted">
                    <label>
                      <span>{t("PhoneNumber")}</span>
                      <span className="required-mark ng-star-inserted">*</span>
                    </label>
                    <div className="input-wrap phone-wrap">
                      <Controller
                        control={control}
                        name="mobile"
                        rules={{
                          required: t("Enter_Mobile"),
                          validate: (value) => {
                            let inputValue = value
                              ?.toString()
                              ?.slice(
                                inputRef?.current?.state?.selectedCountry
                                  ?.countryCode?.length,
                                value?.length,
                              );
                            if (inputValue?.length < 10) {
                              return t("MobileMin");
                            } else if (inputValue?.length > 12) {
                              return t("MobileMax");
                            } else {
                              return true;
                            }
                          },
                        }}
                        render={({ field: { ref, ...field } }) => (
                          <>
                            <PhoneInput
                              {...field}
                              inputExtraProps={{
                                ref,
                                required: true,
                                autoFocus: true,
                              }}
                              ref={inputRef}
                              className="inputrefNew"
                              country={"bd"}
                            />
                          </>
                        )}
                      />
                    </div>
                    {!isEmpty(errors?.mobile?.message) && (
                      <div class="alert ">{errors?.mobile?.message}</div>
                    )}
                  </div>

                  {/* <div className="input-group ng-star-inserted">
                    <label>
                      <span>{t("Email")}</span>
                    </label>
                    <input
                      type="text"
                      inputsanitizer
                      className="input ng-untouched ng-pristine ng-valid"
                      placeholder={t("Email")}
                      {...register("email", {
                        required: t("Pleaseenteremail"),
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: t("Invalidemailaddress"),
                        },
                      })}
                    />
                    {!isEmpty(errors?.email?.message) && (
                      <div class="alert ">{errors?.email?.message}</div>
                    )}
                  </div> */}

                  <div className="input-group ng-star-inserted">
                    <label>
                      <span>{t("ReferCode")}</span>
                    </label>
                    <input
                      type="text"
                      className="input ng-untouched ng-pristine ng-valid"
                      placeholder={t("Enterifyouhaveone")}
                      {...register("refreralCode", {
                        // required: "Please enter agent code",
                      })}
                    />
                  </div>

                  <div className="third-party-login"></div>
                </div>
                {/* <p className="ng-star-inserted">
                  <input
                    type="checkbox"
                    className="register-checkbox ng-untouched ng-pristine ng-valid ng-star-inserted"
                  />

                  <span> {t("Iagreeunderstandthe")} </span>
                  <a href="#"> {t("TC")}</a>
                  <span> </span>
                </p> */}

                <button
                  disabled={loading}
                  className="button btn-primary app-style"
                  style={{
                    border: "none",
                    color: "white",
                    fontSize: "15px",
                    fontWeight: "600",
                    width: "stretch",
                  }}
                  type="submit"
                >
                  {loading ? (
                    <div
                      _ngcontent-serverapp-c381631582=""
                      class="btn-loading"
                    ></div>
                  ) : (
                    t("Submit")
                  )}
                </button>
              </Form>
            </div>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default Register;
